
import { Editor } from "@/components";
import url from "@/constant/url";
import {
  pcaTextArr
} from "element-china-area-data";
import { Result } from "element-ui";

    export default{
        components: {
			Editor,
		},
        data(){
            return{
                tableData:[],
                isEditVisible:false,
                parentCode:'',
                level:'',
                firstClassList:[],
                secondClassList:[],
                thirdClassList:[],
                selectedOptions: [],
                ptLevelList:[], //初始化商品类型等级
                pcaTextArr,
                content: '',
                value: {
                    id:'',
                    images:[],
                    firstClassName:'',
                    secondClassName:'',
                    thirdClassName:'',
                    name:'',
                    post:'0',
                    stock:'',
                    description:'',
                    origin:'',
                    isFreeShipping:'1',
                    isPublished:'1',
                    weight:'',
                    price:''
                },
                isUploadImage:false,
                dialogImageUrl: '',
                srcList: [],
                showDelete:false,
                imgfile:{},
                newFile:''
            }
        },
        mounted() {
            
            console.log('http',this.$http.defaults.baseURL);
            let datas = [];
            let paramter = {
                'pageNum':1,
                'pageSize':10000,
            };
            this.$http.get('product/list',{params:paramter},{
                emulateJSON:true }).then((result:any) =>{
                    datas = result.data.data.data;
                    this.tableData = datas;
            })
        },
        methods:{
            onImageError(event) {
                // 设置一个默认的图片路径或者执行其他错误处理逻辑
                event.target.src = require('@/assets/image-add.png');
            },
            addImage(index:any,row:any){
                // 新增图片
                this.value = {

                    id:row.id,
                    name:row.name,
                    origin:row.origin,
                    images:row.imageList,
                    description:row.description,
                    isFreeShipping:row.isFreeShipping,
                    isPublished:row.isPublished,
                    price:row.price,
                    weight:row.weight,
                    stock:row.stock,
                    post:row.shippingFee
                };

                let tempSrcList = [];
                tempSrcList = row.imageList.map((item:any)=>{
                    return {
                        name: 'img.jpg',
                        url: item.imageUrl,
                        uid: item.imageId
                    }
                });
                if(this.srcList != tempSrcList) {

                    this.srcList = tempSrcList;
                }
                this.isUploadImage = true;
                
            },
            handleClose() {
                this.$confirm('确认关闭？')
                .then(_ => {
                    this.isUploadImage = false;
                })
                .catch(_ => {
                    this.isUploadImage = true;
                });
            },
            handleRemove(file:any) {
                // 删除图片
                this.$http.delete("product/image/single?imageId="+file.uid).then((res: any) =>{

                    if(res.data.code == 200) {

                        this.$confirm('删除成功');
                        window.location.reload();
                    }
                });
            },
            handleImgChange(file:any) {

                // 上传图片
                var formData = new FormData();
                formData.append('file',this.newFile);
                this.$http.post("product/image?productId="+this.value.id,formData,{
                     headers: {
                         'Content-Type': 'multipart/form-data'
                     }
                }).then((res: any) =>{

                    if(res.data.code == 200) {

                        this.$confirm('图片地址成功');
                        window.location.reload();
                    }

                });
            },
            handleExceed() {     
                this.$alert('图片最多上传9张，请删除再重新上传！', '', {
                showConfirmButton: false,
                callback: action => {console.log('上传图片')}
                });
            },
            uploadSectionFile(params:any) {
                // 获取要上传的图片
                // console.log('获取要上传的图片',params);
                let fileType = '';
                let isImage = false;
                let file_url = '';

                this.imgfile = params.file,   //获取上传的文件
                fileType = this.imgfile.type,   //获取文件类型
                console.log('上蹿的时候======',this.imgfile)
                isImage = fileType.indexOf('image') != -1,  //  判断是否是图片类型
                file_url = this.$refs.upload_img.uploadFiles[0].url;
                var isLt5M = this.imgfile.size / 1024 / 1024 < 5;
                
                if (!isLt5M) {  // 判断大小
                    alert("上传图片的大小不能超过 2MB!");
                    this.$refs.upload_img.uploadFiles = [];  //不符合就清空已选择的图片
                    return;
                }
                if(!isImage){  // 文件格式
                    alert("请选择图片文件！");
                    this.$refs.upload_img.uploadFiles = [];  //不符合就清空已选择的图片
                    return;
                }
                
                this.compressImage(this.imgfile);
            },

            handlePublishStatusChange(index:any,row:any){

                //改变商品上架状态
                let isPublished = true;
                if (row.isPublished == true) {
                    
                    isPublished = false;
                } else {
                    isPublished = true;
                }
                let paramter = {
                                id:row.id,
                                isPublished:isPublished
                               };
                this.$http.put("product",paramter).then((res: any) =>{

                    if(res.data.code == 200) {

                        if(row.isPublished == true){

                            this.value.isPublished = '0';
                            this.$confirm('下架成功');
                        } else {
                            this.value.isPublished = '1';
                            this.$confirm('上架成功');
                        }
                    
                        window.location.reload();
                    } else {

                        this.$confirm(res.data.msg);
                    }

                });

            },
            handleDelProduct(index:any,row:any){

                // 删除该条商品记录
                let paramter = {

                    id:row.id
                };
                this.$http.delete("product?id="+row.id).then((res: any) =>{

                    if(res.data.code == 200) {

                        this.$confirm('删除成功');
                        window.location.reload();
                    } else {

                        this.$confirm(res.data.msg);
                    }
                    
                });
                
            },
            handleUpdateProduct(index:any,data:any){

                // 编辑该商品
                this.isEditVisible = true;
                
                let isFreeShippingIndex = '';
                let isPublishedIndex = '';
                if (data.isFreeShipping == true) {
                    
                    isFreeShippingIndex = '1';
                } else {
                    isFreeShippingIndex = '0';
                }
                if (data.isPublished == true) {
                    
                    isPublishedIndex = '1';
                } else {
                    isPublishedIndex = '0';
                }

                this.value = {

                    id:data.id,
                    name:data.name,
                    origin:data.origin,
                    images:data.imageList,
                    description:data.description,
                    isFreeShipping:isFreeShippingIndex,
                    isPublished:isPublishedIndex,
                    price:data.price,
                    weight:data.weight,
                    stock:data.stock,
                    post:data.shippingFee
                }
                this.ptLevelList = data.productCode.split('_'); //分割商品类型
                //获取该商品的商品类型（包括1级2级3级）
                let paramter = {
                                    'name':1,
                                    'pageSize':10000,
                                    'ptLevel':1
                                };
                this.$http.get('productType/list',{params:paramter},{
                    emulateJSON:true }).then((result:any) =>{

                    let datas1 = result.data.data.data;
                    this.firstClassList = datas1;
                    this.firstClassList.forEach(element => {
                        
                        if(element.ptCode == this.ptLevelList[0]){

                            this.value.firstClassName = element.ptName;
                            this.parentCode = element.ptCode;
                            let paramter = {
                                                'pageNum':1,
                                                'pageSize':10000,
                                                'ptLevel':2,
                                                'parentCode':this.parentCode
                                            };
                            this.$http.get('productType/list',{params:paramter},{
                                emulateJSON:true }).then((result:any) =>{
                                
                                let datas2 = result.data.data.data;
                                this.secondClassList = datas2;
                                this.secondClassList.forEach(element => {
                                    
                                    let secondPtCodeList = element.ptCode.split('_'); //分割商品类型

                                    if(secondPtCodeList[1] == this.ptLevelList[1]){

                                        this.value.secondClassName = element.ptName;
                                        this.parentCode = element.ptCode;
                                        let paramter = {
                                                            'pageNum':1,
                                                            'pageSize':10000,
                                                            'ptLevel':3,
                                                            'parentCode':this.parentCode
                                                        };
                                        this.$http.get('productType/list',{params:paramter},{
                                            emulateJSON:true }).then((result:any) =>{
                                                
                                            let datas3 = result.data.data.data;
                                            this.thirdClassList = datas3;
                                            this.thirdClassList.forEach(element => {
                                                
                                                let thirdPtCodeList = element.ptCode.split('_'); //分割商品类型
                                                if(thirdPtCodeList[2] == this.ptLevelList[2]){

                                                    this.value.thirdClassName = element.ptName;
                                                }
                                            });
                                        })
                                    }
                                });
                            })
                        }
                    });
                })
                this.selectedOptions = data.origin.split('/'); //分割产地
                // 商品规格
                let params = {
                                'id':this.value.id,
                               };
                this.$http.get("product",{params:params}).then((res: any) =>{

                    if(res.data.code == 200) {
                        
                        console.log('商品规格',res.data.data);
                        let specList = res.data.data.specification;
                        specList.forEach(element => {
                                                
                            if(element.productId == this.value.id){

                                this.value.weight = element.weight;
                            }
                        });
                    } else {

                        this.$confirm(res.data.msg);
                    }

                });
            },
            changeCode(data:any, type:any){

                this.parentCode = data;
                this.level = type; // 获取商品分类等级
                this.getGoodsClass();
            },
            handleChange() {
                console.log('地址选择器',this.selectedOptions);
            },
            handleCancel(){

                // 取消
                console.log('取消');
                this.isEditVisible = false;
            },
            handleSure(){

                // 商品更新
                this.updateGoodsData();
            },
            // 商品类型接口
            getGoodsClass(){
                
                let datas = [];
                let paramter = {};

                if(this.level == 1){

                    paramter = {
                        'name':1,
                        'pageSize':10000,
                        'ptLevel':this.level
                    };

                } else if(this.level == 2) {

                    paramter = {
                        'pageNum':1,
                        'pageSize':10000,
                        'ptLevel':this.level,
                        'parentCode':this.parentCode,
                    };

                } else {

                    paramter = {
                        'pageNum':1,
                        'pageSize':10000,
                        'ptLevel':this.level,
                        'parentCode':this.parentCode,
                    };
                }

                this.$http.get('productType/list',{params:paramter},{
                    emulateJSON:true }).then((result:any) =>{
                        datas = result.data.data.data;
                        
                        if(this.level == 1) {

                            this.firstClassList = datas;
                            this.firstClassList.forEach(element => {
                                
                                if(element.ptCode == this.ptLevelList[0]){

                                    this.value.firstClassName = element.ptName;
                                    this.parentCode = element.ptCode;
                                }
                            });

                        } else if(this.level == 2) {

                            this.secondClassList = datas;
                            this.secondClassList.forEach(element => {
                                
                                if(element.ptCode == this.ptLevelList[1]){

                                    this.value.secondClassName = element.ptName;
                                    this.parentCode = element.ptCode;
                                }
                            });
                        } else {
                            this.thirdClassList = datas;
                            this.thirdClassList.forEach(element => {
                                
                                if(element.ptCode == this.ptLevelList[1]){

                                    this.value.thirdClassName = element.ptName;
                                }
                            });
                        }
                })
            },
            updateGoodsData(data:any){

                // 更新商品
                let origin = this.selectedOptions[0]+'/'+this.selectedOptions[1]+'/'+this.selectedOptions[2]; //产地
                let isPublishedBool = true;
                let isFreeShoppingBool = true;
                if(this.value.isPublished == 0) {

                    isPublishedBool = false;
                } else {

                    isPublishedBool = true;
                }
                if(this.value.isFreeShipping == 0) {

                    isFreeShoppingBool = false;
                } else {

                    isFreeShoppingBool = true;
                }
                let paramter = {
                                id:this.value.id,
                                isPublished:isPublishedBool,
                                origin:origin,
                                name:this.value.name,
                                description:this.value.description,
                                isFreeShipping:isFreeShoppingBool,
                                productCode:this.parentCode,
                                shippingFee:this.value.post,
                                stock : this.value.stock,
                                price : this.value.price
                               };
                this.$http.put("product",paramter).then((res: any) =>{

                    if(res.data.code == 200) {
                        
                        this.$confirm('修改成功');
                        window.location.reload();
                    } else {

                        this.$confirm(res.data.msg);
                    }

                });
            },
            // 压缩图片
            compressImage(file:any) {

                // 如果不是图片类型的文件，则直接返回
                if (file.type.indexOf('image') === -1) {

                    this.$message.error('请上传图片文件！');
                    return false;
                }
                // 创建FileReader对象
                const reader = new FileReader();
                reader.readAsDataURL(file);
            
                // 载入图片完毕后进行压缩处理
                reader.onload = (e) => {

                    const img = new Image();
                    img.src = e.target.result as string;
                    img.onload = () => {

                        console.log('转换之前的图片',file.name);
                        // 默认设置压缩后的图片最大宽度为800px
                        const maxWidth = 700;
                        // 默认设置压缩后的图片质量为0.8
                        const quality = 0.8;
                
                        // 创建canvas对象用于绘制压缩后的图片
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                
                        // 计算压缩后的图片宽度和高度
                        const ratio = img.width / img.height;
                        let width = maxWidth;
                        let height = width / ratio;
                
                        canvas.width = width;
                        canvas.height = height;
                
                        // 绘制图片
                        ctx.drawImage(img, 0, 0, width, height);
                
                        // 将canvas的内容转为blob数据
                        canvas.toBlob((compressedImageBlob) => {
                            // 使用新的blob对象创建一个新的File对象
                            const newFile = new File([compressedImageBlob], file.name, {
                                type: file.type,
                                lastModified: Date.now(),
                            });
                
                            // 使用新的File对象进行上传
                            this.newFile = newFile;
                            this.handleImgChange(this.newFile);
                        }, file.type, quality);
                    };
                };
            
            },
            
        }
    }
